import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
import Vue from 'vue'
import request from './request'

export default class ItObjectsApi {
  async getObjectDepartments() {
    let getObjectDepartments = await import('./graphql/objects/getObjectDepartments.graphql')
    return (await getApolloClient())
      .query({
        query: gql`${getObjectDepartments}`,
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  async getUsers( userIds, userLogins) {
    let getUsers = await import('./graphql/objects/getUsers.graphql')
    return (await getApolloClient())
      .query({
        query: gql`${getUsers}`,
        variables: { userIds, userLogins }
      })
      .then(this.getUsersCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  getUsersCallback(response) {
    let item = response.data.users
    Vue.prototype.$store.commit('addUsers', item)
    return item
  }
  async personalManagerContacts() {
    let manager = await import('./graphql/objects/personalManagerContacts.graphql')
    return (await getApolloClient('/common'))
      .query({
        query: gql`${manager}`,
      })
      .then(res => res.data.personalManagerContacts)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  async availableOrganizationsForCurrently() {
    return await request( {
      environment: '/tenders',
      type: 'query',
      name: 'availableOrganizationsForCurrently',
      way: './graphql/objects/',
      has_catch: true
    } )
  }
}
